import React from "react";
import { SimpleShowLayout, TextField } from "react-admin";

const Tab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="baseball.id" label="ID" />
      <TextField source="baseball.seasonWins" label="Season Wins" />
      <TextField source="baseball.seasonLosses" label="Season Losses" />
      <TextField source="baseball.seasonTies" label="Season Ties" />
      <TextField
        source="baseball.seasonPercentWins"
        label="Season Percent Wins"
      />
      <TextField source="baseball.districtWins" label="District Wins" />
      <TextField source="baseball.districtLosses" label="District Losses" />
      <TextField source="baseball.districtTies" label="District Ties" />
      <TextField source="baseball.homeWins" label="Home Wins" />
      <TextField source="baseball.homeLosses" label="Home Losses" />
      <TextField source="baseball.homeTies" label="Home Ties" />
      <TextField source="baseball.roadWins" label="Road Wins" />
      <TextField source="baseball.roadLosses" label="Road Losees" />
      <TextField source="baseball.roadTies" label="Road Ties" />
      <TextField source="baseball.streak" label="Streak" />
      <TextField source="baseball.differential" label="Differential" />

      <TextField source="baseball.teamGameCount" label="Team Game Count" />
    </SimpleShowLayout>
  );
};

export default Tab;
